import React from 'react';
import Card from '../components/card';
import parseName from '../modules/parse-name';
import { BorrowerCard } from './card-lenses';

let firstName = null;

const Link = ({ href = '', children }) => (
  <p style={{ padding: '.25em 0' }}>
    <a href={`https://resources.ownup.com/${href}`}>{children}</a>
  </p>
);

const EarlyKickOut = ({ model, ...cardProps }) => {
  const { first } = parseName(model.get('name'));
  if (first) {
    firstName = first;
  }
  return (
    <Card title={`Thanks, ${firstName}. We’ll be in touch.`} buttonType="none" {...cardProps}>
      <hr style={{ margin: '1em 0', border: '1px solid lightgray' }} />
      <h5>Related Articles</h5>
      <Link href="7-reasons-only-1-in-4-homebuyers-shop-for-a-mortgage">
        7 Reasons Only 1 in 4 Homebuyers Shop for a Mortgage
      </Link>
      <Link href="decoding-mortgage-jargon">Decoding Mortgage Jargon</Link>
      <Link href="the-5-dangers-of-mortgage-calculators">
        The 5 Dangers of Mortgage Calculators
      </Link>
    </Card>
  );
};

EarlyKickOut.completed = () => false;

EarlyKickOut.id = 'EarlyKickOut';

export default BorrowerCard(EarlyKickOut);



// WEBPACK FOOTER //
// ./src/cards/early-kick-out.js